// import i18n from "../i18n";
// import store from "../store";
// import { Notification } from "element-ui";
import Vue from 'vue';
import router from "../router";
function errorResponseHandler(res) {
  if (res.resultCode == 1502) {
    router.push({
      name: "login",
    });
  }
  if (res.resultCode != 1001) {
    if (res.hasOwnProperty('data')) {
      Vue.prototype.$notify({
        type: "error",
        message: res.data
      });
    }
  }
}
export default errorResponseHandler;
